define('viewmodels/models/quests/quest',[
    'underscore',
    'knockout',
    'durandal/app'
], function (_, ko, app) {

    var QuestViewModel = function(quests, session, dialog, QuestInfoDialog, QuestChooserDialog, questChooser, router, MessageAlert) {
        var self = this;

        var player = session.getAssociatedPlayer,
            adventure = ko.pureComputed(function() {
                return player().adventurer.getAdventure();
            });

        self.questCompleted = quests.questCompleted;
        self.availableQuests = quests.availableQuests;
        self.currentQuest = adventure.property('currentQuest');
        self.currentObjective = adventure.property('currentObjective');
        self.currentCampaignContent = quests.currentCampaignContent;
        self.leaderboardSummary = ko.deferredComputed(function() {
            return player().questProgress().leaderboardSummary;
        });

        self.openQuestInfoDialog = function(preselectedTabId) {
            dialog.showDialog(new QuestInfoDialog(preselectedTabId));
        };

        self.openQuestChooserDialog = function() {
            dialog.showDialog(new QuestChooserDialog());
        };

        self.questPathPosition = ko.deferredComputed(function() {
            var currentQuest = self.currentQuest(),
                currentObjective = self.currentObjective();
            if (!currentQuest || !currentObjective) {
                return 0;
            }
            var index = currentQuest.objectiveSlugs.indexOf(currentObjective.ruleName);
            return -(52 * index) + 'px';
        });

        self.restartQuest = function() {
            var questId = player().questProgress().quest.name;

            // Set payload and send
            questChooser.setQuestAndDispatch(questId);
        };

        self.isVisible = ko.pureComputed(function() {
            var activeViewModel = router.activeInstruction();
            return activeViewModel && activeViewModel.config && activeViewModel.config.id === 'player';
        });

        self.showQuestTermsDialog = function() {
            var dialogOptions = {
                headerType: '',
                titleInHeader: true,
                showIcon: false,
                textAlign: 'text-left'
            };

            dialog.showAlert(new MessageAlert(
                self.currentQuest.property('name'),
                self.currentCampaignContent.property('terms'),
                null,
                dialogOptions
            ));
        };
    };

    return QuestViewModel;
});

